export enum PatientSubscriptionPaymentStatus {
  SUCCEEDED = 'SUCCEEDED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  AUTHORIZED = 'AUTHORIZED',
  EXPIRED = 'EXPIRED',
}

export enum PatientSubscriptionStatus {
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  TRIALING = 'TRIALING',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  CANCELED = 'CANCELED',
}
